import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CustomerDetail } from '../interfaces/customer-detail.model';
import { CustomerContact } from '../interfaces/customer-contacts.model';
import { CustomerNotes } from '../interfaces/customer-detail-notes.model';
import { DeliveryDestinations, UpdateDeliveryDestinationPayload } from '../interfaces/deliveryDestionations.model';
import { CustomerNotificationHeader } from '../interfaces/customer-notification.model';

export interface CustomerDetailNotification {
  detail: CustomerDetail;
  notificationJson: CustomerNotificationHeader | null;
}

@Injectable({ providedIn: 'root' })
export class CustomerDetailService {
  constructor(private http: HttpClient) {}

  loadCustomerDetail(customerId: string): Observable<CustomerDetailNotification> {
    return this.http.get<CustomerDetail>(`api/clienti/${customerId}`, { observe: 'response' }).pipe(
      map(response => ({
        detail: response.body as CustomerDetail,
        notificationJson: this.parseNotificationHeader(response.headers.get('x-contextnotification')),
      }))
    );
  }

  loadCustomerContacts(businessPartnerId: string): Observable<CustomerContact[]> {
    return this.http.get<CustomerContact[]>(`api/clienti/${businessPartnerId}/contatti`);
  }

  addCustomerContact(businessPartnerId: string, payload: object): Observable<void> {
    return this.http.post<void>(`api/clienti/${businessPartnerId}/contatti`, payload);
  }

  updateCustomerContact(businessPartnerId: string, contactId: string, payload: object): Observable<void> {
    return this.http.put<void>(`api/clienti/${businessPartnerId}/contatti/${contactId}`, payload);
  }

  deleteCustomerContacts(businessPartnerId: string, contactId: string[]): Observable<void> {
    return this.http.delete<void>(`api/clienti/${businessPartnerId}/contatti`, {
      body: contactId,
    });
  }

  loadDeliveryDestinations(businessPartnerId: string): Observable<DeliveryDestinations[]> {
    return this.http.get<DeliveryDestinations[]>(`api/clienti/${businessPartnerId}/destini`);
  }

  updateDeliveryDestination(
    businessPartnerId: string,
    destinationId: string,
    payload: UpdateDeliveryDestinationPayload,
  ): Observable<void> {
    return this.http.put<void>(`api/clienti/${businessPartnerId}/Destini/${destinationId}`, payload);
  }

  loadCustomerNotes(businessPartnerId: string): Observable<CustomerNotes[]> {
    return this.http.get<CustomerNotes[]>(`api/clienti/${businessPartnerId}/note`);
  }

  addCustomerNote(businessPartnerId: string, payload: object): Observable<void> {
    return this.http.post<void>(`api/clienti/${businessPartnerId}/note`, payload);
  }

  updateCustomerNote(businessPartnerId: string, noteId: string, payload: object): Observable<void> {
    return this.http.put<void>(`api/clienti/${businessPartnerId}/note/${noteId}`, payload);
  }

  deleteCustomerNotes(businessPartnerId: string, noteIds: string[]): Observable<void> {
    return this.http.delete<void>(`api/clienti/${businessPartnerId}/note`, {
      body: noteIds,
    });
  }

  parseNotificationHeader(headerValue: string | null): CustomerNotificationHeader | null {
    if (!headerValue) {
      return null;
    }

    try {
      return JSON.parse(headerValue) as CustomerNotificationHeader;
    } catch (error) {
      console.error('Errore parsing header x-contextnotification', error);
      return null;
    }
  }
}
